"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegionTenants = getRegionTenants;
var _cache = require("./internals/cache");
var _fetchConfiguration = require("./internals/fetchConfiguration");
var _loadConfiguration = require("./internals/loadConfiguration");
var _types = require("./types");
var _createConfigurationUrl = require("./utils/createConfigurationUrl");
const CACHE_KEY = 'REGION_TENANTS';
async function getRegionTenants(environment, region, options) {
  const configuration = await (0, _loadConfiguration.loadConfiguration)((0, _cache.createCacheKey)(CACHE_KEY, environment, region), async () => (0, _fetchConfiguration.fetchConfiguration)((0, _createConfigurationUrl.createConfigurationUrl)(_types.ConfigurationType.Hierarchy, environment, region), options?.configurationManagerOptions), {
    withoutCache: options?.withoutCache ?? false
  });
  const tenants = configuration.Tenants.map(tenant => tenant.Tenant.toLowerCase()).sort((a, b) => a.localeCompare(b));
  return tenants;
}
//# sourceMappingURL=getRegionTenants.js.map